import type { RootState } from 'state';
import type { AirportsState } from '../slice';

function getAirports(state: RootState): AirportsState['value'] {
  const { value } = state.packageCache.flightRoutes.airports;
  return value;
}

export default getAirports;
